<template>
	<div>
		<div
			class="row"
			v-bind:class="{
				'border-bottom': position == 'top',
				'border-top': position == 'bottom',
			}"
		>
			<div
				class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6 order-xl-1 order-lg-1 order-md-1 order-sm-1 order-1 py-1 align-self-center"
			>
				<span class="span-fs1">
					Showing {{ value === 1 ? value : (value - 1) * perPage + 1 }} to
					{{ perPage * value }} of {{ total }} rows</span
				>
			</div>
			<div
				class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6 d-md-block d-none align-self-center order-xl-2 order-lg-2 order-md-2 order-sm-3 order-3 py-1"
			>
				<div class="d-flex justify-content-center">
					<ul
						class="pagination"
						:class="[
							size && `pagination-${size}`,
							align && `justify-content-${align}`,
						]"
					>
						<li class="page-item prev-page" :class="{ disabled: value === 1 }">
							<a class="page-link" aria-label="Previous" @click="prevPage">
								<span aria-hidden="true"
									><i class="flaticon-left-1" aria-hidden="true"></i
								></span>
							</a>
						</li>
						<li
							class="page-item"
							:class="{ active: value === item }"
							:key="item"
							v-for="item in range(minPage, maxPage)"
						>
							<a class="page-link" @click="changePage(item)">{{ item }}</a>
						</li>
						<li
							class="page-item next-page"
							:class="{ disabled: value === totalPages }"
						>
							<a class="page-link" aria-label="Next" @click="nextPage">
								<span aria-hidden="true"
									><i class="flaticon-right-2" aria-hidden="true"></i
								></span>
							</a>
						</li>
					</ul>
				</div>
			</div>
			<div
				class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6 py-1 align-self-center order-xl-3 order-lg-3 order-md-3 order-sm-2 order-2 d-flex align-items-center text-right"
			>
				<span class="span-fs1 ml-auto mr-3">Rows per Page</span>

				<WSelect
					placeholder="Rows per page"
					v-model="perPage"
					id="itemPerPage"
					@change="setLimit"
					label=""
					class="default no-label min-select mb-0"
					popperClass="min-select"
				>
					<el-option
						v-for="option in pageOptions"
						:value="option"
						:label="option"
						:key="option"
					>
					</el-option>
				</WSelect>
			</div>
		</div>
	</div>
</template>
<script>
	import WSelect from "@/components/Select";
	export default {
		name: "pagination-block",
		components: {
			WSelect: WSelect,
		},
		props: {
			pageCount: {
				type: Number,
				default: 0,
				description:
					"Pagination page count. This should be specified in combination with perPage",
			},
			total: {
				type: Number,
				default: 0,
				description:
					"Can be specified instead of pageCount. The page count in this case will be total/perPage",
			},
			limit: {
				type: Number,
				default: 1,
				description: "Pagination limit",
			},
			value: {
				type: Number,
				default: 1,
				description: "Pagination value",
			},
			size: {
				type: String,
				default: "",
				description: "Pagination size",
			},
			align: {
				type: String,
				default: "",
				description: "Pagination alignment (e.g center|start|end)",
			},
			pageOptions: {
				type: Array,
				default: () => [10, 15, 25, 50, 100],
			},
			position: {
				type: String,
				default: "",
				description: "border[top,bottom]",
			},
		},
		data() {
			return {
				defaultPagesToDisplay: 5,
				perPage: 10,
			};
		},
		watch: {
			perPage: {
				handler: function (current, old) {
					this.$emit("changeLimit", current);
				},
				deep: true,
			},
			limit: {
				handler: function (current, old) {
					if (this.perPage !== current) {
						this.perPage = current;
					}
				},
				deep: true,
			},
			total() {
				this.$emit("input", 1);
			},
		},
		methods: {
			range(min, max) {
				let arr = [];
				for (let i = min; i <= max; i++) {
					arr.push(i);
				}
				return arr;
			},
			changePage(page) {
				this.$emit("input", page);
				this.$emit("changePage", page);
			},
			nextPage() {
				if (this.value < this.totalPages) {
					this.$emit("input", this.value + 1);
					this.$emit("nextPage", this.value + 1);
				}
			},
			prevPage() {
				if (this.value > 1) {
					this.$emit("input", this.value - 1);
					this.$emit("prevPage", this.value - 1);
				}
			},
			setLimit(limit) {
				localStorage.setItem("pagination-limit", limit);
			},
		},
		computed: {
			totalPages() {
				if (this.pageCount > 0) return this.pageCount;
				if (this.total > 0) {
					return Math.ceil(this.total / this.perPage);
				}
				return 1;
			},
			pagesToDisplay() {
				if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
					return this.totalPages;
				}
				return this.defaultPagesToDisplay;
			},
			minPage() {
				if (this.value >= this.pagesToDisplay) {
					const pagesToAdd = Math.floor(this.pagesToDisplay / 2);
					const newMaxPage = pagesToAdd + this.value;
					if (newMaxPage > this.totalPages) {
						return this.totalPages - this.pagesToDisplay + 1;
					}
					return this.value - pagesToAdd;
				} else {
					return 1;
				}
			},
			maxPage() {
				if (this.value >= this.pagesToDisplay) {
					const pagesToAdd = Math.floor(this.pagesToDisplay / 2);
					const newMaxPage = pagesToAdd + this.value;
					if (newMaxPage < this.totalPages) {
						return newMaxPage;
					} else {
						return this.totalPages;
					}
				} else {
					return this.pagesToDisplay;
				}
			},
		},
	};
</script>
